import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5dfe1e89"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "questionSubmitView" }
const _hoisted_2 = {
  key: 0,
  class: "judge-info"
}
const _hoisted_3 = {
  key: 0,
  class: "judge-item"
}
const _hoisted_4 = {
  key: 1,
  class: "judge-item"
}
const _hoisted_5 = {
  key: 1,
  class: "judge-info"
}
const _hoisted_6 = { class: "code-preview" }
const _hoisted_7 = { class: "code-header" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "提交代码", -1))
const _hoisted_9 = { class: "code-block" }

import { onMounted, ref } from "vue";
import {
  QuestionControllerService,
  QuestionSubmitQueryRequest,
} from "../../../generated";
import message from "@arco-design/web-vue/es/message";
import { useRouter } from "vue-router";
import moment from "moment";


export default /*#__PURE__*/_defineComponent({
  __name: 'QuestionSubmitView',
  setup(__props) {

const router = useRouter();

const dataList = ref<any[]>([]);
const total = ref(0);
const searchParams = ref<QuestionSubmitQueryRequest>({
  questionId: undefined,
  language: undefined,
  status: undefined,
  pageSize: 15,
  current: 1,
});

const loadData = async () => {
  const res = await QuestionControllerService.listQuestionSubmitByPageUsingPost(
    {
      ...searchParams.value,
      sortField: "createTime",
      sortOrder: "descend",
    }
  );
  if (res.code === 0) {
    dataList.value = res.data.records;
    total.value = res.data.total;
  } else {
    message.error("加载失败，" + res.message);
  }
};

onMounted(() => {
  loadData();
});

const columns = [
  { title: "提交号", dataIndex: "id", width: 80 },
  { title: "题目", slotName: "questionId", width: 80 },
  { title: "状态", slotName: "status", width: 100 },
  { title: "语言", slotName: "language", width: 80 },
  { title: "耗时/内存", slotName: "judgeInfo", width: 150 },
  { title: "提交者", dataIndex: "userId", width: 80 },
  { title: "提交时间", slotName: "createTime", width: 150 },
];

const onPageChange = (page: number) => {
  searchParams.value = { ...searchParams.value, current: page };
};

const doSubmit = () => {
  searchParams.value = { ...searchParams.value, current: 1 };
  loadData();
};

const statusMap: Record<number, { text: string; color: string }> = {
  0: { text: "等待中", color: "gray" },
  1: { text: "通过", color: "green" },
  2: { text: "答案错误", color: "red" },
  3: { text: "超时", color: "orangered" },
  4: { text: "超内存", color: "orangered" },
  5: { text: "编译错误", color: "purple" },
  6: { text: "运行错误", color: "red" },
};

const getStatusText = (status: number) => statusMap[status]?.text || "未知";
const getStatusColor = (status: number) => statusMap[status]?.color || "gray";

const langColors: Record<string, string> = {
  java: "orangered",
  cpp: "arcoblue",
  go: "cyan",
  html: "green",
};

const langTexts: Record<string, string> = {
  java: "Java",
  cpp: "C++",
  go: "Go",
  html: "HTML",
};

const getLangColor = (lang: string) => langColors[lang] || "gray";
const getLangText = (lang: string) => langTexts[lang] || lang;

const copyCode = (code: string) => {
  navigator.clipboard.writeText(code || "").then(() => {
    message.success("已复制到剪贴板");
  });
};

return (_ctx: any,_cache: any) => {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_option = _resolveComponent("a-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_link = _resolveComponent("a-link")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_card = _resolveComponent("a-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_card, {
      title: "提交记录",
      bordered: false
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form, {
          model: searchParams.value,
          layout: "inline",
          style: {"margin-bottom":"16px"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form_item, {
              field: "questionId",
              label: "题号"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  modelValue: searchParams.value.questionId,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchParams.value.questionId) = $event)),
                  placeholder: "请输入",
                  "allow-clear": "",
                  onPressEnter: doSubmit
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              field: "language",
              label: "编程语言"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_select, {
                  modelValue: searchParams.value.language,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((searchParams.value.language) = $event)),
                  placeholder: "全部",
                  "allow-clear": "",
                  style: {"width":"140px"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_option, { value: "java" }, {
                      default: _withCtx(() => [
                        _createTextVNode("Java")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_option, { value: "cpp" }, {
                      default: _withCtx(() => [
                        _createTextVNode("C++")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_option, { value: "go" }, {
                      default: _withCtx(() => [
                        _createTextVNode("Go")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_option, { value: "html" }, {
                      default: _withCtx(() => [
                        _createTextVNode("HTML")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              field: "status",
              label: "状态"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_select, {
                  modelValue: searchParams.value.status,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((searchParams.value.status) = $event)),
                  placeholder: "全部",
                  "allow-clear": "",
                  style: {"width":"140px"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_option, { value: 0 }, {
                      default: _withCtx(() => [
                        _createTextVNode("等待中")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_option, { value: 1 }, {
                      default: _withCtx(() => [
                        _createTextVNode("通过")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_option, { value: 2 }, {
                      default: _withCtx(() => [
                        _createTextVNode("答案错误")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_option, { value: 3 }, {
                      default: _withCtx(() => [
                        _createTextVNode("超时")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_option, { value: 4 }, {
                      default: _withCtx(() => [
                        _createTextVNode("超内存")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_option, { value: 5 }, {
                      default: _withCtx(() => [
                        _createTextVNode("编译错误")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_option, { value: 6 }, {
                      default: _withCtx(() => [
                        _createTextVNode("运行错误")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_a_button, {
                  type: "primary",
                  onClick: doSubmit
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("搜索")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"]),
        _createVNode(_component_a_table, {
          columns: columns,
          data: dataList.value,
          pagination: {
          showTotal: true,
          pageSize: searchParams.value.pageSize,
          current: searchParams.value.current,
          total: total.value,
        },
          onPageChange: onPageChange,
          "row-key": "id"
        }, {
          questionId: _withCtx(({ record }) => [
            (record.questionId)
              ? (_openBlock(), _createBlock(_component_a_link, {
                  key: 0,
                  onClick: ($event: any) => (_unref(router).push(`/view/question/${record.questionId}`))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" #" + _toDisplayString(record.questionId), 1)
                  ]),
                  _: 2
                }, 1032, ["onClick"]))
              : _createCommentVNode("", true)
          ]),
          status: _withCtx(({ record }) => [
            _createVNode(_component_a_tag, {
              color: getStatusColor(record.status),
              size: "small"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(getStatusText(record.status)), 1)
              ]),
              _: 2
            }, 1032, ["color"])
          ]),
          judgeInfo: _withCtx(({ record }) => [
            (record.judgeInfo)
              ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
                  (record.judgeInfo.time)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(record.judgeInfo.time) + "ms ", 1))
                    : _createCommentVNode("", true),
                  (record.judgeInfo.memory)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString((record.judgeInfo.memory / 1024).toFixed(1)) + "MB ", 1))
                    : _createCommentVNode("", true)
                ]))
              : (_openBlock(), _createElementBlock("span", _hoisted_5, "-"))
          ]),
          language: _withCtx(({ record }) => [
            _createVNode(_component_a_tag, {
              size: "small",
              color: getLangColor(record.language)
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(getLangText(record.language)), 1)
              ]),
              _: 2
            }, 1032, ["color"])
          ]),
          createTime: _withCtx(({ record }) => [
            _createTextVNode(_toDisplayString(_unref(moment)(record.createTime).format("YYYY-MM-DD HH:mm")), 1)
          ]),
          "expand-row": _withCtx(({ record }) => [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _hoisted_8,
                _createVNode(_component_a_button, {
                  size: "mini",
                  type: "text",
                  onClick: ($event: any) => (copyCode(record.code))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" 复制 ")
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              ]),
              _createElementVNode("pre", _hoisted_9, _toDisplayString(record.code), 1)
            ])
          ]),
          _: 1
        }, 8, ["data", "pagination"])
      ]),
      _: 1
    })
  ]))
}
}

})